import { ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useInView } from "@/hooks/use-in-view";

type Variant = "up" | "fade" | "scale";

interface RevealProps {
  as?: ElementType;
  variant?: Variant;
  delay?: number;
  duration?: number;
  className?: string;
  children: ReactNode;
}

const hiddenByVariant: Record<Variant, string> = {
  up: "opacity-0 translate-y-6",
  fade: "opacity-0",
  scale: "opacity-0 scale-95",
};

const shownByVariant: Record<Variant, string> = {
  up: "opacity-100 translate-y-0",
  fade: "opacity-100",
  scale: "opacity-100 scale-100",
};

const Reveal = ({
  as: Tag = "div",
  variant = "up",
  delay = 0,
  duration = 700,
  className,
  children,
}: RevealProps) => {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <Tag
      ref={ref}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transitionProperty: "opacity, transform",
        willChange: "opacity, transform",
      }}
      className={cn(
        inView ? shownByVariant[variant] : hiddenByVariant[variant],
        className
      )}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
